import ApiV2 from './ApiV2';
import ApiProduto from './ApiProduto';

import CampanhaPublicitariaCategoria from '../constants/CampanhaPublicitariaCategoria';
import Entidade from '../constants/Entidade';

export default class PortalEgressoService {
  static async getCursosGratuitos() {
    return ApiProduto.get(`/portalEgresso/cursos/gratuitos/${Entidade.FACULDADE_UNYLEYA_CURSOS_EXTENSAO}`);
  }

  static async postFaleConosco(data) {
    return ApiV2.post('/portal-egresso/fale-conosco', { data });
  }

  static async getOportunidades(id_entidade) {
    return ApiV2.get(`/campanha-publicitaria`, {
      params: {
        id_entidade,
        bl_portalegresso: 1,
        id_categoria: CampanhaPublicitariaCategoria.OPORTUNIDADES,
      },
    });
  }

  static async getBeneficios(id_entidade) {
    return ApiV2.get(`/campanha-publicitaria`, {
      params: {
        id_entidade,
        bl_portalegresso: 1,
        id_categoria: CampanhaPublicitariaCategoria.BENEFICIOS,
      },
    });
  }
}
